import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-common-strings';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { observer } from 'mobx-react';
import { signout } from '../actions/signout';

const styles = require('./HeaderPane.scss');

const ConsumerLiveEditProfilePageLink = 'https://account.microsoft.com/profile';
const ConsumerLiveAccountSettingsPageLink = 'https://account.microsoft.com';

export interface MeCardPaneProps {
    onDismiss: () => void;
}

@observer
export default class MeCardPane extends React.Component<HeaderPaneProps, {}> {
    componentWillUnmount() {
        this.props.onDismiss();
    }

    private onEditProfileClicked = () => {
        window.open(ConsumerLiveEditProfilePageLink, '_blank');
    };

    private onViewAccountClicked = () => {
        window.open(ConsumerLiveAccountSettingsPageLink, '_blank');
    };

    private onSignoutClicked = () => {
        signout(location);
    };

    render() {
        const userConfiguration = getUserConfiguration();

        return (
            <HeaderFlexPane
                title={() => strings.myAccount}
                onDismiss={this.props.onDismiss}
                content={
                    <div>
                        <PersonaControl
                            name={userConfiguration.SessionSettings.UserDisplayName}
                            emailAddress={userConfiguration.SessionSettings.UserEmailAddress}
                            size={PersonaSize.small}
                            showPersonaDetails={true}
                            hexConsumerIdForUser={userConfiguration.HexCID}
                            className={styles.persona}
                        />
                        <ul className={styles.actions}>
                            {!userConfiguration.SessionSettings.IsShadowMailbox && [
                                <li>
                                    <CommandButton
                                        onClick={this.onEditProfileClicked}
                                        text={strings.editProfile}
                                        className={styles.action}
                                    />
                                </li>,
                                <li>
                                    <CommandButton
                                        onClick={this.onViewAccountClicked}
                                        text={strings.viewAccount}
                                        className={styles.action}
                                    />
                                </li>,
                            ]}
                            <li>
                                <CommandButton
                                    onClick={this.onSignoutClicked}
                                    text={strings.signOut}
                                    className={styles.action}
                                />
                            </li>
                        </ul>
                    </div>
                }
            />
        );
    }
}
